import React from 'react';
import { useIntl } from 'umi';
import { Select, InputAdornment } from 'tea-component';
import type { SelectProps } from 'tea-component';
import NumberInput from '@/pages/datalab/components/NumberInput';

export interface IReferenceLineValue {
  type?: string;
  number?: string | number;
}

interface IValueTypeSelectorProps extends Omit<SelectProps, 'value' | 'onChange'> {
  value?: string;
  onChange?: (type: string) => void;
}

const ValueTypeSelector: React.FC<IValueTypeSelectorProps> = props => {
  const { formatMessage } = useIntl();
  const { value = 'fixed', ...restProps } = props;
  const options = [
    {
      value: 'fixed',
      text: formatMessage({ id: 'dbl_chart_advanced_reference_line_fixed' }),
    },
  ];
  return (
    <Select
      {...restProps}
      appearance="button"
      matchButtonWidth
      options={options}
      value={value}
      disabled={options.length === 1}
    />
  );
};

interface IValueSelectorProps {
  value?: IReferenceLineValue;
  onChange: (value: IReferenceLineValue) => void;
}

const ValueSelector: React.FC<IValueSelectorProps> = ({ value, onChange }) => {
  const { formatMessage } = useIntl();

  return (
    <InputAdornment
      className="dbl-edit-reference-line-value"
      before={
        <ValueTypeSelector
          value={value?.type}
          onChange={(type: string) => onChange({ type })}
        />
      }
    >
      {value?.type === 'fixed' ? (
        <NumberInput
          value={value?.number}
          onChange={number => onChange({ type: value?.type, number })}
          placeholder={formatMessage({
            id: 'dbl_chart_advanced_reference_line_fixed_placeholder',
          })}
        />
      ) : (
        ''
      )}
    </InputAdornment>
  );
};

export default ValueSelector;
